import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { Message } from 'element-ui'
import { Route, RouteConfig } from 'vue-router'
import router from '@/router'
import { PermissionModule } from '@/store/modules/permission'
import { RoleData } from '@/utils/config'
import { getUserId, getUserInfo } from '@/utils/storage'
import store from './store'

NProgress.configure({ showSpinner: false })

const findRouterName: any = (router: RouteConfig) => {
  if (router.children && router.children.length) {
    return findRouterName(router.children[0])
  } else {
    return router.name
  }
}

const whiteList = ['/login'] // 不重定向白名单
router.beforeEach(async (to: Route, _: Route, next: any) => {
  NProgress.start();
  //这里 在一些页面每次进去需要弹窗 但是页面有缓存 所以需要一些判断清除缓存
  store.dispatch('settakeremind', true)
  if (getUserInfo() && getUserId()) {
    if (to.path === '/login') {
      next({
        path: '/'
      })
      NProgress.done();
    }else {
      if (!PermissionModule.dynamicRoutes.length) {
        try {
          PermissionModule.setRoutes('admin');
          router.addRoutes(PermissionModule.dynamicRoutes);
          if (to.path === '/home') {
            next({
              name: findRouterName(PermissionModule.dynamicRoutes),
              replace: true
            })
          } else {
            next({
              ...to,
              replace: true,
            })
          }
          NProgress.done();
        } catch (err) {
          next(`/login?redirect=${to.path}`)
          NProgress.done()
        }
      } else {
        if(to.path === '/aftersales/after-list'&&_.path==='/aftersales/detail'){
          store.dispatch('settakeremind', false)
        } 
        next();
        NProgress.done();
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
      NProgress.done()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})